<section class="listing-detail" [class.listing-detail--off-market]="listing.isOffMarket" style="position: relative;" [additionalOffset]="additionalOffset" [class.luxury]="listingCategory === ListingCategory.LUXURY"
  [class.commercial]="listing.isCommercial">
  <!-- TODO: can we change luxury check here from listingCategory to listing.isLuxury -->
  <app-loader [isLoading]="isLoading"></app-loader>
  <div class="one-column-content">
    <app-listing-summary [listing]="listing" [hasNextListings]="nextListings && nextListings.length > 1" [hasCopiedText]="hasCopiedText"
      [mortgagePaymentAmount]="mortgagePaymentAmount" [showMap]="showMap" [showExpandedGalleryView]="showExpandedGalleryView"
      [isMortgageApplicable]="isMortgageApplicable" (nextListingClicked)="goToNextListing($event)" (previousListingClicked)="goToPreviousListing($event)"
      (showContactAgentClicked)="listing && listing.isLuxury ? onAskQuestion() : showContactAgent()" (toggleExpandedGalleryView)="showExpandedGalleryView = $event"
      (showScheduleViewingClicked)="onScheduleViewing()" (toggleExpandedGalleryView)="showExpandedGalleryView = $event" (homeEstimateLinkClick)="homeEstimateLink($event)"
      [screenSize]="screenSize" [isBrowserMode]="prerenderService.isBrowserMode"></app-listing-summary>
  </div>
  <app-remax-radar [listing]="listing" *ngIf="listing.isOffMarket"></app-remax-radar>
  <section class="suggested-listings separated has-pos-rel" *ngIf="listing.isOffMarket">
    <h3 class="suggested-listings__header">{{('details.find-similar-homes' | translate: {city: listing?.city?.toLowerCase(), province: listing.province})}}</h3>
    <div class="suggested-listings__sub-header-container">
      <p class="suggested-listings__sub-header"  (click)="goToNearbyListingsSearch()" >{{'details.search-for-more-listings' | translate}}</p><i class="material-icons">chevron_right</i>
    </div>
    <!-- <h4 class="title" translate="details.suggested-listings" [translateParams]="{x: suggestedListings.length }"></h4> -->
    <app-item-swiper [isListingDetailPage]="true" [items]="suggestedListings" (itemClicked)="onListingsClicked($event)" [hasFinishedLoadingItems]="hasRetrievedSuggestedListings"></app-item-swiper>
  </section>
  <div *ngIf="listingCategory !== ListingCategory.LUXURY" class="two-column-content">
    <section class="left-column">
      <app-open-house *ngIf="screenSize < SCREEN_SIZE.DESKTOP_UP" [listing]="listing"></app-open-house>
      <section *ngIf="!listing.isOffMarket" class="more-to-see separated">
        <h4 class="title" translate="details.more-to-see"></h4>
        <app-more-to-see [listing]="listing" [showMap]="showMap" (toggleMap)="toggleMap()" [hasPoi]="showPOI" (goToPoi)="goToPoi()"
          (showExpandedGalleryView)="showExpandedGalleryView = true"></app-more-to-see>
      </section>
      <section class="property-overview separated" *ngIf="!listing.isOffMarket">
        <section class="property-description">
          <h4 class="title">
            <b translate="details.property-description"></b>
          </h4>
          <p class="content text-align-justified">{{ listing.description }}</p>
          <span class="courtesy" *ngIf="isCaraBoard">{{listing | courtesyMessage}}</span>

          <!-- TODO: ELLIPSIS AND SHOW MORE -->
        </section>
        <section class="property-details" #collapseDetailSectionsRef>
          <app-detail-section [rows]="listing.highLevelDetailRows" [sectionTitle]="'details.details' | translate" [listingCategory]="listingCategory"></app-detail-section>
          <div class="collapsible-details" [class.collapsed]="!showMore">
            <app-detail-section [listingCategory]="listingCategory" [rows]="listing.keyFactRows" [sectionTitle]="'details.key-facts' | translate"></app-detail-section>
            <app-detail-section [listingCategory]="listingCategory" [rows]="listing.insideRows" [sectionTitle]="'details.inside' | translate"></app-detail-section>
            <app-detail-section [listingCategory]="listingCategory" [rows]="listing.roomDetailRows" [sectionTitle]="'details.room-details' | translate"></app-detail-section>
            <app-detail-section [listingCategory]="listingCategory" [rows]="listing.outsideRows" [sectionTitle]="'details.outside' | translate"></app-detail-section>
            <app-detail-section [listingCategory]="listingCategory" [rows]="listing.utilityRows" [sectionTitle]="'details.utilities' | translate"></app-detail-section>
            <app-detail-section *ngIf="showFeatures" [listingCategory]="listingCategory" [rows]="listing.additionalFeatureRows" [sectionTitle]="'details.features' | translate"></app-detail-section>
          </div>
          <div class="show-more text-center">
            <span (click)="showMorePanel()" role="button" tabindex="0" (keydown.enter)="showMorePanel()">
              <span *ngIf="!showMore">{{ 'details.show-more-details' | translate }}
                <i class="material-icons v-align">keyboard_arrow_down</i>
              </span>
              <span *ngIf="showMore">{{ 'details.show-less-details' | translate }}
                <i class="material-icons v-align">keyboard_arrow_up</i>
              </span>
            </span>
          </div>
        </section>
      </section>

      <section *ngIf="showPOI && !listing.isCommercial && !listing.isLuxury" class="points-of-interest separated" >
        <h4 class="title">
          <b translate="details.points-of-interest"></b>
        </h4>
        <div id="poiWidget"></div>
      </section>

      <section *ngIf="(listing.demographics && !listing.isCommercial)" class="neighbourhood separated">
        <h4 class="title">
          <b translate="details.about-the-neighbourhood"></b>
        </h4>
        <app-demographics-section [demographics]="listing.demographics" [neighbourhood]="listing.neighbourhood" [screenSize]="screenSize"></app-demographics-section>
      </section>

      <section *ngIf="(listing.isCommercial && listing.coAgent) || (!listing.isCommercial && (listing.agent || listing.coAgent))"
        class="agent-profiles separated hide-on-tablet-up">
        <h4 *ngIf="listing.isCommercial " class="title" translate="details.other-associated-agents"></h4>
        <app-agent-card *ngIf="listing.agent" [isLDP]="true" [agent]="listing.agent" [isLuxury]="listing.isLuxury"
          (onAgentEmailClicked)="showContactAgent($event)"></app-agent-card>
        <app-agent-card *ngIf="listing.coAgent" [agent]="listing.coAgent" [isLDP]="true" [isLuxury]="listing.isLuxury"
          (onAgentEmailClicked)="showContactAgent($event)"></app-agent-card>
      </section>
      <section class="suggested-listings separated has-pos-rel" *ngIf="!listing.isOffMarket">
        <h4 class="title" translate="details.suggested-listings" [translateParams]="{x: suggestedListings.length }"></h4>
        <app-item-swiper [items]="suggestedListings" (itemClicked)="onListingsClicked($event)" [hasFinishedLoadingItems]="hasRetrievedSuggestedListings"></app-item-swiper>
      </section>

      <section *ngIf="listing.idxDisclosure" class="hide-on-tablet-down terms">
        <p>
          <img *ngIf="isCaraBoard" src="../../../../assets/icons/CaraIcon.png"  class="cara-logo-footer"   />
          <a *ngIf="isVictoriaRealEstateBoard"
            href="https://vreb.org/vreb-idx-reciprocity-program"
            target="_blank"
            rel="nofollow">
            <img src="../../../../assets/icons/VREBReciprocityLogo.png" height="48" width="95" class="vreb-logo-footer"  />
          </a>
          {{listing.idxDisclosure}}
        </p>

      </section>

    </section>
    <section class="right-column">
      <section class="agent-profiles separated hide-on-mobile" *ngIf="listing.agent || listing.coAgent">
        <app-agent-card *ngIf="listing.agent" [isLDP]="true" [agent]="listing.agent" [isLuxury]="listing.isLuxury"
          (onAgentEmailClicked)="navigateToContactAgentForm($event)"></app-agent-card>
        <app-agent-card *ngIf="listing.coAgent" [agent]="listing.coAgent" [isLDP]="true" [isLuxury]="listing.isLuxury"
          (onAgentEmailClicked)="navigateToContactAgentForm($event)"></app-agent-card>
      </section>

      <app-mortgage-calculator *ngIf="isMortgageApplicable && !listing.isOffMarket" class="separated" [listingPrice]="listing.listPrice" (onMortgagePaymentChange)="mortgagePaymentAmount = $event">
        <div *ngIf="tdAd" [innerHTML]="tdAd | safeHtml"></div>
      </app-mortgage-calculator>

      <app-contact-agent *ngIf="!listing.isOffMarket" [isFixed]="false" (requestSent)="showRequestSent = true" [contactForm]="contactForm" class="separated"
        [leadInfo]="customLeadInfo"
        [listing]="listing" (closeButton)="hideContactAgentPopup()" [listingCategory]="listingCategory" [locationType]="ContactFormLocationType.LISTING_ASK_QUESTION">
      </app-contact-agent>

      <app-ad-card *ngIf="ad && !listing.isOffMarket" [ad]="ad" class="separated"></app-ad-card>

      <div class="blog-posts-section" *ngIf="listing.isOffMarket">
        <app-blog-posts [sourcePage]=BlogPostSourcePage.ListingPage></app-blog-posts>
      </div>
      
      <div class="hide-on-mobile remax-balloon text-center">
        <img *ngIf="listing.isCommercial" src="{{'/assets/REMAX_Logo/CommercialLogo.svg' | staticp }}" height="64" width="212" alt="{{'listing-summary.remax-commercial'}}"
        />
        <ng-container *ngIf="!listing.isCommercial">
          <img src="{{'/assets/BalloonLarge.svg' | staticp}}" alt="{{'listing-summary.remax-logo'|translate}}" height="216" width="170"
          />
          <p style="font-size: 21px;">
            <b translate="details.sign-of-a-remax-agent"></b>
          </p>
        </ng-container>
      </div>
      <section *ngIf="listing.idxDisclosure" class=" hide-on-tablet-landscape-up terms">
        <p>{{listing.idxDisclosure}}</p>
      </section>
    </section>
  </div>
  <div *ngIf="listingCategory === ListingCategory.LUXURY" class="luxury-details">
    <app-open-house [listing]="listing"></app-open-house>
    <div class="video-virtual-tour text-center is-flex is-flex-column">
      <a [attr.disabled]="!listing.videoUrl" class="outer-box" [attr.href]="listing.videoUrl" target="_blank" rel="noopener">
        <span class="inner-box" translate="listing-summary.video"></span>
      </a>
      <a [attr.disabled]="!listing.virtualTourUrl" class="outer-box" [attr.href]="listing.virtualTourUrl" target="_blank" rel="noopener">
        <span class="inner-box" translate="listing-summary.virtual-tour"></span>
      </a>
    </div>
    <h3 class="headline">
      {{ listing.headline }}
    </h3>
    <h4 class="description">
      {{ listing.description }}
    </h4>
    <div class="has-flex-content-space-between details-inclusions-amenities">
      <div class="outer-box">
        <div class="box">
          <div class="content full-height">
            <div class="logo is-flex has-flex-align-center has-flex-content-center" style="width: 85px; height: 85px">
              <svg ngNonBindable viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                  <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="a">
                    <stop stop-color="#FFF" offset="0%" />
                    <stop stop-color="#EAEAEA" offset="100%" />
                  </linearGradient>
                  <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="b">
                    <stop stop-color="transparent" offset="0%" />
                    <stop stop-color="#FFF" offset="35%" />
                    <stop stop-color="#FFF" offset="100%" />
                  </linearGradient>
                </defs>
                <g transform="translate(-172 -30)" stroke="white" stroke-width="2.4" fill="none" fill-rule="evenodd" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M199.972 65.417h39.724v27.807h-39.724zM211.89 81.307h15.89M211.89 69.39v-7.945M227.78 69.39v-7.945" />
                  <circle stroke-width="2.2" fill="transparent" cx="219" cy="78" r="40" stroke="url(#b)" />
                </g>
              </svg>
            </div>
            <div class="title text-center" translate="details.details"></div>
            <div class="divider"></div>
            <app-detail-section [listingCategory]="listingCategory" [rows]="listing.highLevelDetailRows" [mlsNum]="listing.mlsNum"></app-detail-section>
          </div>
        </div>
      </div>
      <div class="outer-box">
        <div class="box">
          <div class="content full-height">
            <div class="logo is-flex has-flex-align-center has-flex-content-center" style="width: 85px; height: 85px">
              <svg ngNonBindable viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                  <linearGradient x1="0%" y1="566.757%" x2="631.756%" y2="0%" id="a">
                    <stop stop-color="#FFF" offset="0%" />
                    <stop stop-color="#EAEAEA" offset="100%" />
                  </linearGradient>
                  <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="b">
                    <stop stop-color="transparent" offset="0%" />
                    <stop stop-color="#FFF" offset="35%" />
                    <stop stop-color="#FFF" offset="100%" />
                  </linearGradient>
                </defs>
                <g transform="translate(33 35)" stroke="white" stroke-width="3.12" fill="none" fill-rule="evenodd" stroke-linecap="round"
                  stroke-linejoin="round">
                  <g transform="translate(3)">
                    <circle cx="3.12" cy="3.12" r="3.12" />
                    <circle cx="3.12" cy="15.6" r="3.12" />
                    <circle cx="3.12" cy="28.08" r="3.12" />
                    <path d="M 12 3.12 h 15.6 M 12 15.6 h 15.6 M 12 28.08 h 15.6" />
                  </g>
                  <circle cx="17" cy="17" r="40" stroke-width="2.2" stroke="url(#b)" />
                </g>
              </svg>
            </div>
            <div class="title text-center" translate="details.inside"></div>
            <div class="divider"></div>
            <app-detail-section [listingCategory]="listingCategory" [rows]="listing.insideRows"></app-detail-section>
          </div>
        </div>
      </div>
      <div class="outer-box">
        <div class="box">
          <div class="content full-height">
            <div class="logo is-flex has-flex-align-center has-flex-content-center" style="width: 85px; height: 85px">
              <svg ngNonBindable viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                  <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="a">
                    <stop stop-color="#FFF" offset="0%" />
                    <stop stop-color="#EAEAEA" offset="100%" />
                  </linearGradient>
                  <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="b">
                    <stop stop-color="transparent" offset="0%" />
                    <stop stop-color="#FFF" offset="35%" />
                    <stop stop-color="#FFF" offset="100%" />
                  </linearGradient>
                </defs>
                <g transform="translate(25 25)" stroke="white" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke-width="2.2" d="M9.438 13.213h26.426L39.64 39.64H5.663zM30.202 13.213a7.55 7.55 0 0 0-15.101 0" />
                  <circle stroke-width="1.1" fill="url(#a)" cx="15.101" cy="20.764" r="1.888" />
                  <circle stroke-width="1.1" fill="url(#a)" cx="30.202" cy="20.764" r="1.888" />
                  <circle stroke-width="2.2" fill="transparent" cx="23" cy="23" r="40" stroke="url(#b)" />
                </g>
              </svg>
            </div>
            <div class="title text-center" translate="details.outside"></div>
            <div class="divider"></div>
            <app-detail-section [listingCategory]="listingCategory" [rows]="listing.outsideRows"></app-detail-section>
          </div>
        </div>
      </div>
    </div>

    <app-accordion class="accordion">
      <app-accordion-item [index]="0" [label]="'details.details'" [textOnly]="false">
        <app-detail-section [listingCategory]="listingCategory" [rows]="listing.highLevelDetailRows" [mlsNum]="listing.mlsNum"></app-detail-section>
      </app-accordion-item>
      <app-accordion-item [index]="1" [label]="'details.inside'" [textOnly]="false">
        <app-detail-section [listingCategory]="listingCategory" [rows]="listing.insideRows"></app-detail-section>
      </app-accordion-item>
      <app-accordion-item [index]="2" [label]="'details.outside'" [textOnly]="false">
        <app-detail-section [listingCategory]="listingCategory" [rows]="listing.outsideRows"></app-detail-section>
      </app-accordion-item>
    </app-accordion>

    <div class="neighbourhood-wrapper" *ngIf="listing.neighbourhood">
      <h3 class="headline neighbourhood-headline" translate="details.about-the-neighbourhood">
      </h3>
      <div class="neighbourhood-map">
        <app-map [latLng]="centerLatLng" [customMapOptions]="customMapOptions" [isOffice]="false" [isLDP]="false">
        </app-map>
      </div>
      <div class="neighbourhood-info">
        <div class="neighbourhood-border">
          <div class="neighbourhood-content">
            <h4>{{ listing.neighbourhood.name }}</h4>
            <div class="is-flex solid-line-wrapper-luxury">
              <div class="empty-placeholder"></div>
              <div class="solid-line-luxury"></div>
              <div class="empty-placeholder"></div>
            </div>
            <h5 class="description">
              {{ screenSize === SCREEN_SIZE.MOBILE_ONLY ? listing.neighbourhood.reducedCharacterMobile : listing.neighbourhood.reducedCharacterDesktop }}
            </h5>
            <a class="learn-more" [routerLink]="[listing.neighbourhood.detailUrl]">
              <span>{{ 'details.learn-more' | translate }} &gt;</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="contact-agent is-flex has-flex-content-center">
      <button class="btn btn-luxury" (click)="onAskQuestion()">
        <span translate="listing-summary.request-more-details"></span>
      </button>
    </div>
    <div class="agents is-flex">
      <app-agent-card *ngIf="listing.agent" class="flex-one" [agent]="listing.agent" [isLDP]="true" [isLuxury]="listing.isLuxury" (onContactAgent)="showContactAgent($event)"></app-agent-card>
      <app-agent-card *ngIf="listing.coAgent" class="flex-one" [agent]="listing.coAgent" [isLDP]="true" [isLuxury]="listing.isLuxury" (onContactAgent)="showContactAgent($event)"></app-agent-card>
    </div>

    <section *ngIf="listing.idxDisclosure" class="terms">
      <p>{{listing.idxDisclosure}}</p>
    </section>
  </div>

  <app-request-sent *ngIf="showRequestSent" (onClose)="showRequestSent = false" [nameToDisplay]="agentToContactName"></app-request-sent>
  <app-modal [shouldShowModal]="contactAgent" (closeModal)="hideContactAgentPopup()" [allowOutsideClickToClose]="false" [templateRef]="contactAgentModal"></app-modal>
  <ng-template #contactAgentModal>
    <app-contact-agent [listing]="listing" [contactForm]="contactForm" [isFixed]="false" (requestSent)="hideContactAgentPopup(); showRequestSent = true"
      [leadInfo]="customLeadInfo"
      [listingCategory]="listingCategory" [locationType]="activeContactFormLocationType" [headerTemplate]="contactAgentProfileTemplate"></app-contact-agent>
  </ng-template>
</section>

<ng-template #contactAgentProfileTemplate>
  <h4 class="tagline" *ngIf="activeContactFormLocationType !== ContactFormLocationType.LISTING_SCHEDULE_VIEWING">
    <b *ngIf="listing && listing.isLuxury" [translate]="contactFormTitle ? contactFormTitle : 'contact.request-more-details'"></b>
    <b *ngIf="listing && !listing.isLuxury && screenSize !== SCREEN_SIZE.MOBILE_ONLY" translate="contact.request-more-info"></b>
    <b *ngIf="!(listing && listing.isLuxury) && screenSize === SCREEN_SIZE.MOBILE_ONLY" translate="contact.request-more-info"></b>
  </h4>
  <h4 class="tagline" *ngIf="activeContactFormLocationType === ContactFormLocationType.LISTING_SCHEDULE_VIEWING">
    <b translate="contact.schedule-a-viewing"></b>
  </h4>
  <ng-container *ngIf="shouldShowContactAgentHeaderTemplate">
    <div class="is-flex has-flex-align-start has-flex-content-start agent-details">
      <a [routerLink]="[agentOnContactForm ? agentOnContactForm.detailUrl : listing.agent.detailUrl]" [title]="'contact.aria.viewProfile' | translate">
        <img width="85" class="img lazypreload lazyload" *ngIf="!shouldShowInitials" [url]="agentOnContactForm ? agentOnContactForm.associatePhoto : listing.agent.associatePhoto" imageQualityPercentage="75"
          [alt]="'contact.aria.agentPicture' | translate" (error)="imgErrorHandler($event)" [keepAspectRatio]="true" appImgLoader
          appImgIxImage>
        <app-circle-initials *ngIf="shouldShowInitials" [initials]="agentOnContactForm ? agentOnContactForm.agentInitials : listing.agent.agentInitials"></app-circle-initials>
      </a>
      <div class="details-info">
        <div class="logo">
          <img src="{{'assets/REMAX_Logo/' + (listing.isCommercial?'REMAX_Commercial.svg':listing.isLuxury?'REMAX_Collection.svg': 'REMAX_masterLogo@1x.svg') |staticp }}"
            alt="{{'listing-summary.remax-commercial'|translate}}">
        </div>
        <div class="text">
          <h4>
            <a [routerLink]="[agentOnContactForm ? agentOnContactForm.detailUrl : listing.agent.detailUrl]">{{agentOnContactForm ? agentOnContactForm.fullName : listing.agent.fullName}}</a>
          </h4>
          <p>
            {{ agentOnContactForm ?
            ((agentOnContactForm.agentIncorporation && agentOnContactForm.agentIncorporation !== 'Personal Real Estate Corporation') ? listing.agentIncorporation : agentOnContactForm.officeName) :
            ((listing.agent.agentIncorporation && listing.agent.agentIncorporation !== 'Personal Real Estate Corporation') ? listing.agentIncorporation : listing.agent.officeName) }}
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
